import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Partners } from '@com-delta-omnichannel/aura';

@Component({
  selector: 'idp-partners-ui',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent {
  @Input() content: Partners = {} as Partners;
  @Output() clickAnalyticsEvent = new EventEmitter<string>();

  redirect(link: string) {
    this.clickAnalyticsEvent.emit(link);
    window.open(link, '_blank');
  }
}
